import { render } from "./PricingCardEditor.vue?vue&type=template&id=55449636&scoped=true"
import script from "./PricingCardEditor.vue?vue&type=script&lang=js"
export * from "./PricingCardEditor.vue?vue&type=script&lang=js"

import "./PricingCardEditor.vue?vue&type=style&index=0&id=55449636&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55449636"]])

export default __exports__